import { render, staticRenderFns } from "./DescriptionHouse.vue?vue&type=template&id=5064c150"
import script from "./DescriptionHouse.vue?vue&type=script&lang=js"
export * from "./DescriptionHouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports